export const foglalkozasData = [
{
        "date": "2026-01-23",
        "title":"Kézművesség",
       "mainimage":"../images/nappali/2026.01.23/1.jpg",
        "images": 
          {
          "image1": "../images/nappali/2026.01.23/1.jpg",
          "image2": "../images/nappali/2026.01.23/2.jpg",
          "image3": "../images/nappali/2026.01.23/3.jpg",
          "image4": "../images/nappali/2026.01.23/4.jpg",
          "image5": "../images/nappali/2026.01.23/5.jpg",
          "image6": "../images/nappali/2026.01.23/6.jpg",
          "image7": "../images/nappali/2026.01.23/7.jpg",
          "image8": "../images/nappali/2026.01.23/8.jpg",
          "image9": "../images/nappali/2026.01.23/9.jpg",
          "image10": "../images/nappali/2026.01.23/10.jpg",
          }
        
    },
    {
        "date": "2026-01-05",
        "title":"Mesenap",
       "mainimage":"../images/nappali/2026.01.05/7.jpg",
        "images": 
          {
          "image1": "../images/nappali/2026.01.05/1.jpg",
          "image2": "../images/nappali/2026.01.05/2.jpg",
          "image3": "../images/nappali/2026.01.05/3.jpg",
          "image4": "../images/nappali/2026.01.05/4.jpg",
          "image5": "../images/nappali/2026.01.05/5.jpg",
          "image6": "../images/nappali/2026.01.05/6.jpg",
          "image7": "../images/nappali/2026.01.05/7.jpg",
          "image8": "../images/nappali/2026.01.05/8.jpg",
          "image9": "../images/nappali/2026.01.05/9.jpg",
          }
        
    },
    {
        "date": "2025-06-08",
        "title":"Kertészkedés",
       "mainimage":"../images/nappali/2025.06.08/1.jfif",
        "images": 
          {
          "image1": "../images/nappali/2025.06.08/1.jfif",
          "image2": "../images/nappali/2025.06.08/2.jfif",
          "image3": "../images/nappali/2025.06.08/3.jfif",
          "image4": "../images/nappali/2025.06.08/4.jfif",
          "image5": "../images/nappali/2025.06.08/5.jfif",
          "image6": "../images/nappali/2025.06.08/6.jfif",
          "image7": "../images/nappali/2025.06.08/7.jfif",
          "image8": "../images/nappali/2025.06.08/8.jfif",
          "image9": "../images/nappali/2025.06.08/9.jfif",
          }
        
    },
     {
        "date": "2026-02-06",
        "title":"Rajzolás",
       "mainimage":"../images/nappali/2026.02.06/4.jpg",
        "images": 
          {
          "image1": "../images/nappali/2026.02.06/1.jpg",
          "image2": "../images/nappali/2026.02.06/2.jpg",
          "image3": "../images/nappali/2026.02.06/3.jpg",
          "image4": "../images/nappali/2026.02.06/4.jpg",
          "image5": "../images/nappali/2026.02.06/5.jpg",
          "image6": "../images/nappali/2026.02.06/6.jpg",
          "image7": "../images/nappali/2026.02.06/7.jpg",
          "image8": "../images/nappali/2026.02.06/8.jpg",
          "image9": "../images/nappali/2026.02.06/9.jpg",
          }
        
    },
     {
        "date": "2026-07-31",
        "title":"Egy kis játék",
       "mainimage":"../images/nappali/2026.07.31/4.jpg",
        "images": 
          {
          "image1": "../images/nappali/2026.07.31/1.jpg",
          "image2": "../images/nappali/2026.07.31/2.jpg",
          "image3": "../images/nappali/2026.07.31/3.jpg",
          "image4": "../images/nappali/2026.07.31/4.jpg",
          "image5": "../images/nappali/2026.07.31/5.jpg",
          "image6": "../images/nappali/2026.07.31/6.jpg",
          "image7": "../images/nappali/2026.07.31/7.jpg",
          "image8": "../images/nappali/2026.07.31/8.jpg",
          "image9": "../images/nappali/2026.07.31/9.jpg",
          }
    },
    {
    "date": "2026.07.24",
    "title": "Rengeteg ügyességi játék",
    "mainimage": "../images/nappali/2026.07.24/1.jpg",
    "images":
    {
      "image1": "../images/nappali/2026.07.24/1.jpg",
      "image2": "../images/nappali/2026.07.24/2.jpg",
      "image3": "../images/nappali/2026.07.24/3.jpg",
      "image4": "../images/nappali/2026.07.24/4.jpg",
      "image5": "../images/nappali/2026.07.24/5.jpg",
      "image6": "../images/nappali/2026.07.24/6.jpg",
      "image7": "../images/nappali/2026.07.24/7.jpg",
      "image8": "../images/nappali/2026.07.24/8.jpg",
      "image9": "../images/nappali/2026.07.24/9.jpg",
      "image10": "../images/nappali/2026.07.24/10.jpg",
      "image11": "../images/nappali/2026.07.24/11.jpg",
      "image12": "../images/nappali/2026.07.24/12.jpg",
      "image13": "../images/nappali/2026.07.24/13.jpg",
      "image14": "../images/nappali/2026.07.24/14.jpg",
      "image15": "../images/nappali/2026.07.24/15.jpg",
      "image16": "../images/nappali/2026.07.24/16.jpg",
      "image17": "../images/nappali/2026.07.24/17.jpg",
      "image18": "../images/nappali/2026.07.24/18.jpg",
      "image19": "../images/nappali/2026.07.24/19.jpg",
      "image20": "../images/nappali/2026.07.24/20.jpg",
      "image22": "../images/nappali/2026.07.24/21.jpg",
      "image22": "../images/nappali/2026.07.24/22.jpg",
      "image23": "../images/nappali/2026.07.24/23.jpg",
      "image24": "../images/nappali/2026.07.24/24.jpg",
      "image25": "../images/nappali/2026.07.24/25.jpg",
      "image26": "../images/nappali/2026.07.24/26.jpg",
      "image27": "../images/nappali/2026.07.24/27.jpg",
      "image28": "../images/nappali/2026.07.24/28.jpg",
      "image29": "../images/nappali/2026.07.24/29.jpg",
      "image30": "../images/nappali/2026.07.24/30.jpg",
      "image31": "../images/nappali/2026.07.24/31.jpg",
      "image32": "../images/nappali/2026.07.24/32.jpg",
      "image33": "../images/nappali/2026.07.24/33.jpg",     
    }
  },
    ];